import { Button as ChakraButton, CloseButton } from '@chakra-ui/react'
import { FileInput, FileUploadClearTrigger, FileUploadDropzone, FileUploadList, FileUploadRoot } from "./native"
import { UI } from "components"
import { Field, Group } from '..'

export function Button({ icon, ...props }){
    return(
    <Field {...props}>
        <FileUploadRoot gap="1" maxWidth="300px" {...props}>
            <Group
                w="full"
                startElement={<UI.Icon name={icon ?? 'upload'} />}
                endElement={<FileUploadClearTrigger asChild><CloseButton me="-1" size="xs" variant="plain" focusVisibleRing="inside" focusRingWidth="2px" pointerEvents="auto" color="fg.subtle" /></FileUploadClearTrigger>}
            >
                <FileInput {...props} />
            </Group>
        </FileUploadRoot>
    </Field>
    )
}

export function Dropzone({ maxFiles = 1, ...props }){
    return(
    <FileUploadRoot maxW="xl" alignItems="stretch" maxFiles={maxFiles}>
        <FileUploadDropzone
          label="Drag and drop here to upload"
          description=".png, .jpg up to 5MB"
          maxH="100px"
          {...props}
        />
        <FileUploadList />
    </FileUploadRoot>
    )
}